
(() => {
  function activate(menu, index) {
    const triggers = menu.querySelectorAll(
      '[data-product-mega-trigger]'
    );
    const panels = menu.querySelectorAll(
      '[data-product-mega-panel]'
    );

    triggers.forEach((trigger) => {
      const active =
        trigger.dataset.productMegaTrigger === index;

      trigger.classList.toggle('is-active', active);

      if (active) {
        trigger.setAttribute('aria-current', 'true');
      } else {
        trigger.removeAttribute('aria-current');
      }
    });

    panels.forEach((panel) => {
      const active =
        panel.dataset.productMegaPanel === index;

      panel.hidden = !active;
      panel.classList.toggle('is-active', active);
    });
  }

  function initMenu(menu) {
    if (menu.dataset.productMegaInitialized === 'true') {
      return;
    }

    menu.dataset.productMegaInitialized = 'true';

    const triggers = menu.querySelectorAll(
      '[data-product-mega-trigger]'
    );

    triggers.forEach((trigger) => {
      const index = trigger.dataset.productMegaTrigger;

      trigger.addEventListener('mouseenter', () => {
        activate(menu, index);
      });

      trigger.addEventListener('focus', () => {
        activate(menu, index);
      });
    });

    const firstTrigger = triggers[0];

    if (firstTrigger) {
      activate(
        menu,
        firstTrigger.dataset.productMegaTrigger
      );
    }
  }

  function initAllMenus(root = document) {
    root
      .querySelectorAll('[data-product-mega-menu]')
      .forEach(initMenu);
  }

  document.addEventListener('DOMContentLoaded', () => {
    initAllMenus();
  });

  // Concept может подгружать содержимое меню после открытия.
  // Поэтому инициализируем новые панели, когда они появляются.
  const observer = new MutationObserver(() => {
    initAllMenus();
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true
  });

  document.addEventListener('shopify:section:load', (event) => {
    initAllMenus(event.target);
  });

  initAllMenus();
})();